import InputComponent from "../../components/elements/InputComponent";
import { IFormData } from "../../pages/seller-stepper/SellerStepper";
import RadioCheckbox from "../elements/RadioCheckbox";
import UploderComponent from "../elements/UploderComponent";
import ButtonComponent from "../elements/ButtonComponent";
import { useEffect, useState } from "react";
import InputNotControlled from "../elements/InputNotControlled";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFnsJalali } from "@mui/x-date-pickers/AdapterDateFnsJalali";
import moment from "jalali-moment";
import { axiosPrivate } from "../../api/axios";
import { motion } from "framer-motion";
import { z } from "zod";
import customZ from "../../utils/setZodCustomMessages";
import {
  idCardFieldSchema,
  nationalCodeSchema,
  notEmptyAndPersianField,
  notEmptyDate,
  phonenumberSchema,
} from "../../utils/customSchemas";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  childVariants,
  childVariantsLeft,
  childVariantsRight,
} from "../../animation/RoutesAnimations";
import UserIcon, { CalenderIcon, IdCardIcon, PhonenumberIcon } from "../Icons";
// import ModalOtp from "../modals/ModalOtp";
import { toast } from "react-toastify";
import Lottie from "react-lottie";
import animationData from "../../../src/jsons/LoadingBg.json";
import axios from "axios";
import {
  GET_FILE,
  // LOAN_GET_CREDIT,
  USER_FILL_IDENTITY_INFO,
  USER_GET_IDENTITY_INFO,
  USER_IDENTITY_INFO_UPDATE,
} from "../../api/apiClient";
import { useUserContext } from "../../context/UserContext";
import UploadImageWithTools from "../common/UploadImageWithTools";

export interface IdTitleOwnershipModel {
  id: number;
  title: string;
}
const step1Schema = customZ.object({
  first_name: notEmptyAndPersianField,
  last_name: notEmptyAndPersianField,
  father_name: notEmptyAndPersianField,
  phonenumber: phonenumberSchema,
  national_id: nationalCodeSchema,
  birth_date: notEmptyDate,
  id_card: idCardFieldSchema,
  marital_status: z
    .string()
    .refine((value) => value === "SINGLE" || value === "MARRIED", {
      message: "Please select a valid option",
    }),
  gender: z.string().refine((value) => value === "m" || value === "f", {
    message: "Please select a valid option",
  }),
});

function SellerFormStep1({ formNo, setFormNo, isInSeller }: any) {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },

    watch,
  } = useForm<IFormData>({
    resolver: (data, context, options) => {
      return zodResolver(step1Schema)(data, context, options);
    },
  });
  const [isLoadingContents, setIsLoadingContents] = useState<boolean>(false);

  const { userData } = useUserContext();

  const [imageData, setImageData] = useState(null);
  const access_token = localStorage.getItem("access_token");
  const [identityInfo, setIdentityInfo] = useState<any>(null);
  const [filledItems, setFilledItems] = useState<any>(false);
  // const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [phoneNumber, setphoneNumber] = useState<any>("");

  const phone_Number_value = userData?.phone_number;

  const [isImageLoading, setIsImageLoading] = useState(true);
  const [isSubmiting, setIsSubmiting] = useState(false);

  const [editabel, setEditabel] = useState(false);

  const [initialGender, setInitialGender] = useState();
  const [id_card, setId_card] = useState();
  const [birth_date, setBirth_date] = useState();
  const [father_name, setFather_name] = useState();
  const [last_name, setLast_name] = useState();
  const [first_name, setFirst_name] = useState();
  const [initialMaritalStatus, setInitialMaritalStatus] = useState();
  const [sendImageToApi, setsendImageToApi] = useState<boolean>(false);

  const [dataFromOcr, setDataFromOcr] = useState<any>(null);

  const watchedGender = watch("gender");
  const watchedMaritalStatus = watch("marital_status");
  const watchedid_card = watch("id_card");
  const watchedbirth_date = watch("birth_date");
  const watchedfather_name = watch("father_name");
  const watchedlast_name = watch("last_name");
  const watchedfirst_name = watch("first_name");

  useEffect(() => {
    if (
      watchedGender !== initialGender ||
      watchedMaritalStatus !== initialMaritalStatus ||
      watchedid_card !== id_card ||
      watchedbirth_date !== birth_date ||
      watchedfather_name !== father_name ||
      watchedlast_name !== last_name ||
      watchedfirst_name !== first_name
    ) {
      setEditabel(true);
    }
  }, [
    watchedGender,
    watchedMaritalStatus,
    initialGender,
    initialMaritalStatus,
    watchedid_card,
    id_card,
    watchedbirth_date,
    birth_date,
    watchedfather_name,
    father_name,
    watchedlast_name,
    last_name,
    watchedfirst_name,
    first_name,
  ]);

  const fetchImage = async () => {
    try {
      const response = await axiosPrivate.get(
        GET_FILE(identityInfo?.id_card_uid),
        {
          headers: {
            accept: "application/json",
            // prettier-ignore
            "Authorization": `Bearer ${access_token}`,
            "Content-Type": "multipart/form-data",
          },

          withCredentials: true,
        }
      );

      setImageData(response?.data?.data?.url);
      setIsImageLoading(false);
    } catch (error) {
      setIsImageLoading(false);
      toast.warning(`دریافت تصاویر با خطا مواجه شد.
      لطفا مجددا بررسی نمایید.`);

      console.error("Error fetching image data:", error);
    }
  };

  useEffect(() => {
    if (identityInfo?.id_card_uid) {
      fetchImage();
    }
  }, [identityInfo?.id_card_uid]);

  const genderOptions = [
    { label: "مرد", value: "m" },
    { label: "زن", value: "f" },
  ];

  const maritalOptions = [
    { label: "مجرد", value: "SINGLE" },
    { label: "متاهل", value: "MARRIED" },
  ];

  const onSubmitStep1: SubmitHandler<IFormData> = async (data: IFormData) => {
    setphoneNumber(data?.phonenumber);
    setIsSubmiting(false);

    setFormNo(formNo + 1);
    // try {
    //   const response = await axiosPrivate.get(LOAN_GET_CREDIT, {
    //     headers: {
    //       // prettier-ignore
    //       "accept": "application/json",
    //       // prettier-ignore
    //       "Authorization": `Bearer ${access_token}`,
    //     },
    //     withCredentials: true,
    //   });

    //   if (response?.status >= 200 && response?.status < 400) {
    //   }
    // } catch (error: any) {
    //   console.error("An error occurred:", error);
    //   setIsSubmiting(false);
    //   // setIsLoginOpen(true);

    //   const responseStatus: any = (error as any).response?.status;

    //   if (responseStatus === 500) {
    //     toast.error("ارتباط با سرور برقرار نشد.");
    //   }
    //   if (responseStatus === 401) {
    //     toast.error("لطفا مجددا وارد شوید.");
    //     // setIsLoginOpen(false);
    //   }
    //   if (responseStatus === 404) {
    //     toast.warning("اعتبار سنجی میبایست انجام شود");
    //   }
    // }
  };

  useEffect(() => {
    setValue("phonenumber", phone_Number_value ? phone_Number_value : null);
  }, [userData]);

  const getIdentityInfo = async () => {
    setIsLoadingContents(true);
    setIsSubmiting(true);
    setIsImageLoading(true);

    try {
      const response = await axiosPrivate.get(USER_GET_IDENTITY_INFO, {
        headers: {
          // prettier-ignore
          "accept": "application/json",
          // prettier-ignore
          "Authorization": `Bearer ${access_token}`,
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      });
      setIdentityInfo(response?.data?.data);
      setInitialGender(response?.data?.data?.gender);
      setFirst_name(response?.data?.data?.first_name);
      setLast_name(response?.data?.data?.last_name);
      setBirth_date(response?.data?.data?.birth_date);
      setFather_name(response?.data?.data?.father_name);
      setId_card(response?.data?.data?.id_card_uid);
      setInitialMaritalStatus(response?.data?.data?.marital_status);
      setValue("gender", response?.data?.data?.gender);
      setValue("marital_status", response?.data?.data?.marital_status);
      setValue("id_card", response?.data?.data?.id_card_uid);
      setValue("father_name", response?.data?.data?.father_name);
      setValue("birth_date", response?.data?.data?.birth_date);
      setValue("last_name", response?.data?.data?.last_name);
      setValue("first_name", response?.data?.data?.first_name);

      if (response?.status >= 200 && response?.status < 300) {
        setIsLoadingContents(false);
        setFilledItems(true);
        setIsSubmiting(false);
      } else {
        setIsLoadingContents(false);
      }
    } catch (error) {
      setIsLoadingContents(false);

      setIsImageLoading(false);
      setIsSubmiting(false);
    } finally {
      setIsLoadingContents(false);
    }
  };

  useEffect(() => {
    getIdentityInfo();
  }, []);

  useEffect(() => {
    setValue(
      "first_name",
      dataFromOcr?.name ? dataFromOcr?.name : identityInfo?.first_name
    );
    setValue(
      "last_name",
      dataFromOcr?.last_name ? dataFromOcr?.last_name : identityInfo?.last_name
    );
    setValue(
      "national_id",
      dataFromOcr?.national_id
        ? dataFromOcr?.national_id
        : identityInfo?.national_id
    );
    setValue(
      "birth_date",
      dataFromOcr?.birth_date
        ? new Date(
            moment(dataFromOcr?.birth_date, "jYYYY-jMM-jDD").format(
              "YYYY-MM-DD"
            )
          )
        : identityInfo?.birth_date.replace(/\//g, "-")
    );

    setValue(
      "father_name",
      dataFromOcr?.father_name
        ? dataFromOcr?.father_name
        : identityInfo?.father_name
    );

    if (identityInfo?.gender) {
      setValue("gender", identityInfo?.gender);
    }
    if (identityInfo?.marital_status) {
      setValue("marital_status", identityInfo?.marital_status);
    }
    if (identityInfo?.id_card_uid) {
      setValue("id_card", identityInfo?.id_card_uid);
    }
  }, [setValue, identityInfo, dataFromOcr]);

  const confirmUserDetail: SubmitHandler<IFormData> = async (
    data: IFormData
  ) => {
    const birthDate = new Date(data.birth_date);

    const timeZoneOffset = birthDate.getTimezoneOffset() * 60000;

    const adjustedDate = new Date(birthDate.getTime() - timeZoneOffset);

    const adjustedDateString = adjustedDate.toISOString().split("T")[0];

    if (!filledItems) {
      const formattedData = {
        ...data,
        birth_date:
          data?.birth_date instanceof Date
            ? adjustedDateString
            : adjustedDateString,
      };
      setIsSubmiting(true);
      try {
        const response = await axiosPrivate.post(
          USER_FILL_IDENTITY_INFO,
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );

        if (response?.status >= 200 && response?.status < 300) {
          onSubmitStep1(data);
          setIsSubmiting(false);
        } else {
          console.error(
            "ERROR in acceptRules:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        setIsSubmiting(false);

        if (axios.isCancel(error)) {
          toast.error("API request canceled.");
        }
      }
    }

    const formattedData = {
      ...data,
      id_card: sendImageToApi ? data?.id_card : null,
      birth_date:
        data?.birth_date instanceof Date
          ? adjustedDateString
          : adjustedDateString,
    };

    if (filledItems && editabel) {
      setIsSubmiting(true);
      try {
        const response = await axiosPrivate.put(
          USER_IDENTITY_INFO_UPDATE,
          formattedData,
          {
            headers: {
              // prettier-ignore
              "accept": "application/json",
              // prettier-ignore
              "Authorization": `Bearer ${access_token}`,
              "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
          }
        );

        if (response?.status >= 200 && response?.status < 300) {
          onSubmitStep1(data);
          setIsSubmiting(false);
        } else {
          console.error(
            "ERROR in acceptRules:",
            response.data || response.statusText
          );
        }
      } catch (error) {
        console.error("An unexpected error occurred:", error);
        setIsSubmiting(false);
      }
    }

    if (filledItems && !editabel) {
      onSubmitStep1(data);
    }
  };

  // const closeModal = () => {
  //   setIsLoginOpen(false);
  //   // setFormNo(formNo + 1);
  //   setFilledItems(true);
  //   const body = document.querySelector("body");
  //   if (body) {
  //     body.classList.remove("overflow-hidden");
  //   }
  // };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  return (
    <>
      {isLoadingContents ? (
        <>
          <div className=" full-screen">
            <Lottie options={defaultOptions} height={100} width={100} />
          </div>
        </>
      ) : (
        <motion.form
          variants={childVariants}
          initial="initial"
          animate="final"
          onSubmit={handleSubmit(confirmUserDetail)}
          className="flex flex-col flex-1 item-center justify-center gap-12  rounded-md shadow-md pb-20"
        >
          <div className="flex flex-col item-center justify-center">
            <div className="lg:flex flex-1 lg:flex-auto gap-12 justify-center rounded-md shadow-md  ">
              <div className="basis-1/2 md:mr-10 mr-2">
                <div className="flex gap-3 flex-col mb-2 ">
                  <motion.div
                    variants={childVariantsRight}
                    initial="initial"
                    animate="final"
                    className="mb-5 "
                  >
                    <div className="mb-1">
                      <InputNotControlled
                        size="regular"
                        isRequired
                        label="شماره موبایل"
                        name="phonenumber"
                        default_phone={
                          phone_Number_value ? phone_Number_value : null
                        }
                        disabled
                        control={control}
                        errors={errors?.phonenumber}
                        svgIcon={<PhonenumberIcon />}
                      />
                    </div>

                    <UploadImageWithTools
                      setValue={setValue}
                      mainLabel={"تصویر کارت ملی"}
                      control={control}
                      errors={errors}
                      name={"id_card"}
                      imageData={imageData}
                      setImageData={setImageData}
                      setsendImageToApi={setsendImageToApi}
                      isImageLoading={isImageLoading}
                    />

                    <div className="flex mt-6 md:gap-8 flex-col md:flex-row">
                      <RadioCheckbox
                        editable={true}
                        defaultValue={
                          identityInfo?.gender ? identityInfo?.gender : ""
                        }
                        label="جنسیت"
                        name="gender"
                        isRequired
                        options={Object.values(genderOptions)}
                        control={control}
                        errors={errors?.gender}
                      />

                      <RadioCheckbox
                        defaultValue={identityInfo?.marital_status}
                        editable={true}
                        label="وضعیت تاهل"
                        name="marital_status"
                        isRequired
                        options={Object.values(maritalOptions)}
                        control={control}
                        errors={errors?.marital_status}
                      />
                    </div>
                  </motion.div>
                </div>
              </div>
              <div className="mt-8 md:mt-[0px] basis-1/2 mr-2 md:mr-10 ">
                <motion.div
                  variants={childVariantsLeft}
                  initial="initial"
                  animate="final"
                  className="flex flex-col gap-3"
                >
                  <InputComponent
                    defaultValue={
                      identityInfo?.first_name
                        ? identityInfo?.first_name
                        : undefined
                    }
                    size="regular"
                    isRequired
                    label="نام"
                    name="first_name"
                    control={control}
                    errors={errors?.first_name}
                    svgIcon={<UserIcon />}
                  />

                  <InputComponent
                    dataFromOcr={dataFromOcr?.last_name}
                    fromOCR={dataFromOcr?.last_name}
                    value={dataFromOcr?.last_name || ""}
                    defaultValue={
                      identityInfo?.last_name
                        ? identityInfo?.last_name
                        : undefined
                    }
                    size="regular"
                    isRequired
                    label="نام خانوادگی"
                    name="last_name"
                    control={control}
                    errors={errors?.last_name}
                    svgIcon={<UserIcon />}
                  />

                  <InputComponent
                    dataFromOcr={dataFromOcr?.father_name}
                    fromOCR={dataFromOcr?.father_name}
                    value={dataFromOcr?.father_name || ""}
                    defaultValue={
                      identityInfo?.father_name
                        ? identityInfo?.father_name
                        : undefined
                    }
                    size="regular"
                    isRequired
                    label="نام پدر"
                    name="father_name"
                    control={control}
                    errors={errors?.father_name}
                    svgIcon={<UserIcon />}
                  />
                  <InputComponent
                    dataFromOcr={dataFromOcr?.national_id}
                    fromOCR={dataFromOcr?.national_id}
                    value={dataFromOcr?.national_id || ""}
                    defaultValue={
                      identityInfo?.national_id
                        ? identityInfo?.national_id
                        : undefined
                    }
                    size="regular"
                    isRequired
                    editable={true}
                    label="کد ملی"
                    type="tel"
                    name="national_id"
                    control={control}
                    errors={errors?.national_id}
                    maxLength={10}
                    svgIcon={<IdCardIcon />}
                  />

                  <>
                    <Controller
                      control={control}
                      name="birth_date"
                      rules={{ required: true }}
                      render={({ field }) => {
                        return (
                          <LocalizationProvider
                            dateAdapter={AdapterDateFnsJalali}
                            dateFormats={{ monthShort: "MMMM" }}
                            localeText={{
                              fieldMonthPlaceholder: () => "ماه",
                              fieldDayPlaceholder: () => "روز",
                              fieldYearPlaceholder: () => "سال",
                            }}
                          >
                            <div className="flex flex-col gap-0 mt-1 mb-4">
                              <div className="flex">
                                <label className=" text-gray-900 text-Body-OneLine/14/Regular">
                                  تاریخ تولد
                                </label>
                                {<span className="text-red-500">*</span>}
                              </div>

                              <DatePicker
                                slots={{
                                  openPickerIcon: CalenderIcon,
                                }}
                                disableFuture
                                value={
                                  dataFromOcr?.birth_date
                                    ? new Date(
                                        moment(
                                          dataFromOcr?.birth_date,
                                          "jYYYY-jMM-jDD"
                                        ).format("YYYY-MM-DD")
                                      )
                                    : identityInfo?.birth_date
                                    ? new Date(identityInfo?.birth_date)
                                    : null
                                }
                                onChange={(date) => {
                                  field.onChange(date);
                                }}
                                closeOnSelect={true}
                                slotProps={{
                                  inputAdornment: {
                                    position: "start",
                                  },
                                }}
                                sx={{
                                  svg: {
                                    color: errors?.birth_date ? "#B91C1C" : "",
                                  },
                                  width: "100%",
                                  "& .MuiOutlinedInput-root": {
                                    height: "44px",
                                    border: "none",
                                    borderRadius: "0.5rem",
                                  },
                                  "& .MuiDialogActions-root": {
                                    bgcolor: "#F9FAFB !important",
                                  },
                                  "& .MuiInputBase-root.Mui-focused": {
                                    bgcolor: "#F9FAFB !important",
                                  },
                                  "& .MuiInputBase-root": {
                                    bgcolor: errors?.birth_date
                                      ? "#FEE2E2"
                                      : "#F9FAFB !important",
                                  },
                                  "& MuiInputBase-root-MuiOutlinedInput-root": {
                                    bgcolor: "red",
                                  },
                                }}
                                className={`mb-0 ${
                                  errors?.birth_date ? "border-date-error " : ""
                                } `}
                                defaultValue={
                                  identityInfo?.birth_date
                                    ? new Date(
                                        moment(
                                          identityInfo?.birth_date,
                                          "jYYYY-jMM-jDD"
                                        ).format("YYYY-MM-DD")
                                      )
                                    : null
                                }
                                views={["year", "month", "day"]}
                                openTo="year"
                              />
                              {errors?.birth_date ? (
                                <p
                                  className={`text-Body-OneLine/14/Regular text-red-600`}
                                >
                                  وارد کردن این مقدار الزامی است
                                </p>
                              ) : (
                                <div
                                  className={`"flex items-center justify-center text-Body-OneLine/14/Regular text-gray-500"`}
                                ></div>
                              )}
                            </div>
                          </LocalizationProvider>
                        );
                      }}
                    />
                  </>
                </motion.div>
              </div>
            </div>
            <div className="flex w-full justify-center gap-1 pb-4 sticky bottom-0 bg-white right-0 left-0">
              <ButtonComponent
                className="mt-8 w-[120px] h-10"
                variant="outlined"
                disabled
                onClick={() => setFormNo(formNo - 1)}
              >
                بازگشت
              </ButtonComponent>
              <ButtonComponent
                type="submit"
                className="mt-8 w-[120px] h-10"
                variant="filled"
                isClicked={isSubmiting}
                disabled={isSubmiting}
              >
                ادامه
              </ButtonComponent>
            </div>
          </div>
        </motion.form>
      )}
      {/* {isLoginOpen && (
        <ModalOtp
          isInSeller={isInSeller}
          phoneNumber={phoneNumber}
          onClose={closeModal}
          setFormNo={setFormNo}
          formNo={formNo}
        />
      )} */}
    </>
  );
}

export default SellerFormStep1;
